<template>
    <!--<div v-bind:class="{ 'm-featured-posts hero' : resultItem.IsFirst }" v-bind:style="[resultItem.IsFirst ? {'background': 'url(' +  resultItem.Image.Url + ')'} : '']">-->
    <article class="result-card">
        <div class="result-card__image" v-if="!hideImage">
            <thumbnail-image :photo-id="resultItem.Image.Id" v-if="resultItem.Image"></thumbnail-image>
        </div>
        <div class="full result-card__inner flow">
            <div class="result-card__header">
                <h3 class="result-card__title">
                    <a :href="articleUrl">
                        {{resultItem.Heading}}
                    </a>
                </h3>
                <!-- <span class="visually-hidden">Blog post</span> -->
            </div>
            <!-- <result-tags :tag-parents="resultItem.TagParents"></result-tags> -->
            <div class="result-card__content flow max-width-s">
                <div class="result-card__meta">
                    <strong>Blog | </strong>
                    <span>Published {{formatDate(resultItem.Date.DateTime)}}</span>
                    <span v-if="blogDetails.AuthorName" class="result-card__author">by <strong>{{blogDetails.AuthorName}}</strong></span>
                    <span v-if="topicUrls && Object.keys(topicUrls).length">
                        in
                        <span class="result-card__topics">
                            <span
                                v-for="(url, name) in topicUrls"
                                :key="name"
                                class="topic-item"
                            >
                                <a :href="url">{{ name }}</a>
                            </span>
                        </span>
                    </span>
                </div>
                <!-- <p class="date">
                    Published {{formatDate(resultItem.Date.DateTime)}}
                    <span v-if="blogDetails.AuthorName">by <strong>{{blogDetails.AuthorName}}</strong></span>
                    <span v-if="topicUrls">
                        in
                        <span class="result-card__topics">
                            <span v-for="(url, name) in topicUrls" :key="name">
                                <a :href="url">{{ name }}</a>
                            </span>
                        </span>
                    </span>
                    <span v-if="blogDetails.TopicUrl && blogDetails.TopicName">
                        in
                        <a :href="blogDetails.TopicUrl">
                            {{ blogDetails.TopicName }}
                        </a>
                    </span>
                </p> -->
                <p>{{truncate(resultItem.Summary)}}</p>
            </div>
            <div class="result-card__footer">
                <div class="flex-row">
                    <a :href="articleUrl" class="btn result-card__footer-btn" v-if="resultItem.Link" :aria-labelledby="'search-list-item-' + resultItem.Id">
                        Find out more
                    </a>
                    <span v-if="blogDetails && blogDetails.ReadTime">
                        {{ blogDetails.ReadTime }} min read
                    </span>
                </div>
                <profile-actions :page-id="resultItem.Id.toString()" class="text-blue"></profile-actions>
            </div>
        </div>
    </article>
</template>

<script>
    import Globals from '@/globals.js'
    import ProfileActions from '@/components/Utils/profile-actions'
    import ThumbnailImage from '@/components/Utils/thumbnail-image'
    // import ResultTags from '@/components/SiteSearch/result-tags'
    import { globalMixin } from '@/mixins/globalMixin.js'
    import { format, toDate } from '@/utils/date.js'
    import { truncate } from '@/utils/strings.js'

    export default {
        components: {
            ProfileActions,
            ThumbnailImage,
            // ResultTags
        },

        computed: {
            articleUrl() {
                const url = this.resultItem.Link.Url
                if (!url) return url
                const npid = this.$store.getters.nestedPropertyId
                if (npid) {
                    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'npid=' + npid
                }
                return url
            },
            blogDetails() {
                return (this.resultItem && this.resultItem.Content && this.resultItem.Content.BlogDetails) || null
            },

            topicUrls() {
                const topicParent = this.resultItem.TagParents.find(tp => tp.Name === 'Topic')
                if (!topicParent || !topicParent.Children) return null

                const mapping = {}

                topicParent.Children.forEach(childName => {
                    const index = this.resultItem.Tagged.indexOf(childName)

                    if (index >= 0 && this.resultItem.TaggedFilterParamters[index]) {
                        mapping[childName] = this.resultItem.TaggedFilterParamters[index]
                    }
                })

                return Object.keys(mapping).length ? mapping : null
            }
        },

        methods: {
            formatDate(date) {
                return format(toDate(date), Globals.dateFormatUi)
            },

            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            }
        },

        mixins: [globalMixin],

        props: {
            resultItem: {
                required: true,
                type: Object
            },
            hideImage: {
                required: false,
                type: Boolean
            },
            tagsToShow: {
                required: false,
                type: Array
            }
        }
    }
</script>